
export default function PointGuide() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-4">
          dポイントの貯め方・使い方
        </h2>
        <p className="text-center text-gray-600 mb-12">
          日常のあらゆるシーンでdポイントが貯まる
        </p>

        {/* 貯め方 */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-[#E60033] mb-6 flex items-center gap-2">
            <i className="ri-add-circle-line"></i>
            dポイントの貯め方
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-[#E60033] rounded-full flex items-center justify-center">
                  <i className="ri-shopping-bag-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#003366]">通常のお買物</h4>
                  <p className="text-2xl font-bold text-[#E60033]">1%還元</p>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                100円（税込）につき1ポイント。コンビニ、スーパー、ネットショッピングなど、どこでも貯まります。
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-[#E60033] rounded-full flex items-center justify-center">
                  <i className="ri-smartphone-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#003366]">ドコモ料金</h4>
                  <p className="text-2xl font-bold text-[#E60033]">5%還元</p>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                ドコモのケータイ・ドコモ光の利用料金1,000円（税抜）ごとに50ポイント還元。
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-[#E60033] rounded-full flex items-center justify-center">
                  <i className="ri-fire-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#003366]">ポイ活MAX</h4>
                  <p className="text-2xl font-bold text-[#E60033]">最大11%還元</p>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                ドコモ ポイ活 MAXプラン契約で、通常1%+キャンペーン10%の合計11%還元。上限5,000ポイント/月。
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-[#E60033] rounded-full flex items-center justify-center">
                  <i className="ri-store-2-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#003366]">dポイント加盟店</h4>
                  <p className="text-2xl font-bold text-[#E60033]">+1%〜</p>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                ローソン、マツキヨ、すき家、ファミマなど、dポイントカード提示+dカード決済でさらにポイントアップ。
              </p>
            </div>
          </div>
        </div>

        {/* 使い方 */}
        <div>
          <h3 className="text-2xl font-bold text-[#003366] mb-6 flex items-center gap-2">
            <i className="ri-exchange-line"></i>
            dポイントの使い方
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-[#FFF5F5] rounded-xl p-6 text-center">
              <div className="w-14 h-14 bg-[#E60033] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bank-card-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-[#003366] mb-2">
                カード利用代金に充当
              </h4>
              <p className="text-sm text-gray-600">
                dカードの利用代金の支払いにdポイントを充当できます。
              </p>
            </div>

            <div className="bg-[#FFF5F5] rounded-xl p-6 text-center">
              <div className="w-14 h-14 bg-[#E60033] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-store-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-[#003366] mb-2">
                街のお店で使う
              </h4>
              <p className="text-sm text-gray-600">
                dポイント加盟店で1ポイント=1円として利用可能。
              </p>
            </div>

            <div className="bg-[#FFF5F5] rounded-xl p-6 text-center">
              <div className="w-14 h-14 bg-[#E60033] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-smartphone-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-[#003366] mb-2">
                ケータイ料金に充当
              </h4>
              <p className="text-sm text-gray-600">
                毎月のドコモ料金の支払いにポイントを使えます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
